import { useEffect } from 'react';

/**
 * Variation of React.useEffect hook meant to only run once on component's mount with support for unmount callback
 */
export const useOnMount = (callback: () => void) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
};
